import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import IconInfoWarning from '@/assets/icons/icon_info_warning.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const ListWrapper = styled(TransitionGroup)(() =>
  mq({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
    ],
    gridGap: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const List = styled.li(() =>
  mq({
    width: ['100%', '100%', '100%', '100%', '630px'],
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const RaceProgramInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '52px',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
    ],
  }),
);

export const StopHeldText = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    margin: [
      '0 auto',
      '0 auto',
      `0 0 0 ${defaultTheme.spacing.l}`,
      `0 0 0 ${defaultTheme.spacing.l}`,
    ],
    padding: [
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
      '0',
      '0',
    ],
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    order: ['3', '3', '2', '2'],
  }),
);

export const InfoWarningIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${IconInfoWarning}) no-repeat center`,
    backgroundSize: 'cover',
    width: '16px',
    height: '16px',
    marginRight: defaultTheme.spacing.xs,
  }),
);

export const ProgramName = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    marginTop: defaultTheme.spacing.s,
    width: '100%',
    order: ['2', '2', '3', '3'],
  }),
);

export const LinkWrapper = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    display: 'grid',
    gridTemplateColumns: [
      'repeat(4, 1fr)',
      'repeat(4, 1fr)',
      'repeat(6, 1fr)',
      'repeat(6, 1fr)',
    ],
    gridGap: '4px',
    gridAutoRows: '45px',
  }),
);

export const linkStyle = styled.div(() =>
  mq({
    padding: `${defaultTheme.spacing.m} 0`,
    color: defaultTheme.color.secondary,
    fontSize: defaultTheme.font.size.m,
    textAlign: 'center',
    border: `1px solid ${defaultTheme.color.grayScale.medium}`,
    backgroundColor: defaultTheme.background.mediumLightGray,
    borderRadius: defaultTheme.border.radius.s,
    '& > span': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const ActiveLink = styled(linkStyle)(() =>
  mq({
    ...hoverOpacity,
  }),
).withComponent(Link);

export const DisabledLink = styled(linkStyle)(() =>
  mq({
    opacity: defaultTheme.button.opacity.disabled,
  }),
);

export const CancelLink = styled(linkStyle)(() =>
  mq({
    color: defaultTheme.text.gray,
    backgroundColor: defaultTheme.background.mediumGray,
    border: `1px solid ${defaultTheme.border.color.mediumGray}`,
  }),
);
